import { Button, Heading, Section, Text } from '@react-email/components';
import { formatDate } from 'common/formatters';

import EmailLayout from './EmailLayout/EmailLayout';
// import Heading from './Heading';
import Message from './common/Message';
import Regards from './common/Regards';
import NextSteps from './common/NextSteps';

const PatientAction = ({
    patientName,
    businessName,
    buisnessEmail, //required phone number here
    appointmentTime, //24 hour format
    appointmentDate,
    providerName,
    location,
    visitCost,
    serviceNames,
    appointmentId
}) => {
    const today = new Date().toISOString().split('T')[0];
    const formattedTime = new Date(`${today}T${appointmentTime}`).toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
    });

    const formattedDate = formatDate(appointmentDate);
    const nextStepsList = [
        'Click the link below to review and confirm your appointment details.',
        'Once you’ve accepted, your appointment will be confirmed, and you’ll receive a confirmation email with next steps.',
    ];
    return (
        <EmailLayout>
            <Section>
                <Message style={{ color: '#95CFD3' }}>Action Required</Message>
                <Heading style={{ textAlign: 'center' }}>Hi, {patientName}</Heading>
                <Text
                    style={{
                        textAlign: 'start',
                        color: '#3E3E4A',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        fontWeight: 400,
                        lineHeight: 'normal',
                    }}
                >
                    We’ve scheduled an appointment for you at {businessName}. Please review and confirm:
                </Text>
            </Section>

            {/* Appointment Details */}
            <Section style={{ paddingTop: '12px' }}>
                <Heading as="h3" style={{ borderBottom: '1px solid #C4C4C4', color: '#3E3E4A' }}>Appointment Details</Heading>
                <Text style={{ color: '#3E3E4A' }}>
                    <strong>Provider Name:</strong> {providerName}
                </Text>
                <Text style={{ color: '#3E3E4A' }}>
                    <strong>Date & Time:</strong> {formattedDate} at {formattedTime}
                </Text>
                <Text style={{ color: '#3E3E4A' }}>
                    <strong>Practice Name:</strong> {businessName}
                </Text>
                <Text style={{ color: '#3E3E4A' }}>
                    <strong>Location:</strong> {location}
                </Text>
                <Text style={{ color: '#3E3E4A' }}>
                    <strong>Cost of Visit:</strong> ${visitCost}
                </Text>
                <Text style={{ color: '#3E3E4A' }}>
                    <strong>Service(s):</strong> {serviceNames}
                </Text>
            </Section>

            {/* Next Steps */}
            <NextSteps heading="What You Need to Do:" stepsList={nextStepsList} />

            {/* Confirm Button */}
            <Section style={{ textAlign: 'center', marginTop: '20px' }}>
                <Button
                    style={{
                        padding: '10px 30px',
                        backgroundColor: '#FF5F39',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '28px',
                        cursor: 'pointer',
                        fontSize: '12px',
                        fontWeight: 500,
                        fontFamily: 'Poppins, sans-serif',
                        cursor: 'pointer'
                    }}
                    // href='http://localhost:3001/'
                    href={`${process.env.REACT_APP_PATIENT_PORTAL_URL}/auth/login?appointmentId=${encodeURIComponent(appointmentId)}`}

                >
                    Review & Confirm Appointment
                </Button>
            </Section>

            {/* For New & Existing Patients */}
            <Section style={{ paddingTop: '12px' }}>
                <Heading style={{ borderBottom: '1px solid #C4C4C4', color: '#3E3E4A' }} as="h3">
                    For New Patients:
                </Heading>

                <Text>You’ll be prompted to create an account before confirming your appointment.</Text>

                <Heading style={{ borderBottom: '1px solid #C4C4C4', color: '#3E3E4A' }} as="h3">
                    For Existing Patients:
                </Heading>

                <Text>
                    Sign in to your account, and the appointment details will appear for you to review and accept.
                </Text>
                <Text>
                    If you have any questions or need assistance, feel free to contact us at <a href={`mailto:${buisnessEmail}`}>{buisnessEmail}</a>.
                </Text>

                <Text>We look forward to seeing you soon!</Text>
            </Section>

            <Section>
                <Regards />
            </Section>
        </EmailLayout>
    );
};

export default PatientAction;
